<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :columns="tableColumns"
      :enableSearch="false"
      :queryParams="queryParams"
      :operationBoxStyle="{padding: '0 0 16px'}"
      :requestPromise="loadDataList"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建
      </a-button>
      <template v-slot:action="{ record }">
        <a-space>
          <a @click="onEditEvent(record)">编辑</a>
          <a @click="onSwitchStatus(record)">{{ record.status == 1 ? '禁用' : '启用' }}</a>
        </a-space>
      </template>
    </StandardSearchPageView>
    <SimpleFormEditorDialog
      v-if="showDialog"
      ref="formEditor"
      :editConfigList="editConfigList"
      :item="selectItem"
      :rules="formRules"
      :title="selectItem && selectItem.id ? '编辑' : '新建'"
      @cancel="showDialog = false"
      :width="600"
      @ok="onEditResultEvent"
    />
  </div>
</template>

<script>
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import {
  editConfigList,
  tableColumns
} from '../config/associatedAccount.config.js'

export default {
  name: 'AssociatedAccountComponent',
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data() {
    return {
      showDialog: false,
      selectItem: undefined,
      queryParams: {},
      editConfigList,
      tableColumns,
      formRules: {
        channelUserName: [{ required: true, message: '请输入渠道用户名' }],
        baseUrl: [{ required: true, message: '请输入渠道URL' }],
        channelAccount: [{ required: true, message: '请输入渠道账号' }],
        password: [{ required: true, message: '请输入密码' }]
      }
    }
  },
  methods: {
    getSourceService() {
      return this.getHttpServices().getSourceService()
    },
    loadDataList(params) {
      const { limitDto = {} } = params
      return this.getSourceService()
        .post('dahengqin/platform/account_list', {
          merchantId: this.$store.getters.userInfo.merchantId,
          pageNum: limitDto.pageNum || 1,
          pageSize: limitDto.pageSize || 10
        })
        .then(res => ({
          data: res.data,
          totalCount: res.totalCount,
          pageCount: res.pageCount
        }))
    },
    onSwitchStatus(item) {
      this.getSourceService()
        .post('dahengqin/platform/account_status_update', {
          id: item.id,
          merchantId: this.$store.getters.userInfo.merchantId,
          status: Number(item.status) === 1 ? 0 : 1
        })
        .then(() => {
          this.$message.success('操作成功！')
          this.refreshData(false)
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '操作失败，请重试！')
          console.error(err)
        })
    },
    onEditEvent(item) {
      this.selectItem = { ...item }
      this.showDialog = true
    },
    onAddEvent() {
      this.selectItem = {}
      this.showDialog = true
    },
    refreshData(resetPage) {
      if (this.$refs.table) {
        this.$refs.table.refresh(resetPage)
      }
    },
    buildSaveParams(params = {}) {
      const { id, channelUserName, baseUrl, channelAccount, password, remark } = params
      const requestParams = {
        merchantId: this.$store.getters.userInfo.merchantId,
        channelUserName,
        baseUrl,
        channelAccount,
        password: password || ''
      }
      if (id != null) requestParams.id = id
      if (remark) requestParams.remark = remark
      return requestParams
    },
    onEditResultEvent(params) {
      const isEdit = !!(params && params.id)
      const url = isEdit
        ? 'dahengqin/platform/account_edit'
        : 'dahengqin/platform/account_create'
      this.getSourceService()
        .post(url, this.buildSaveParams(params))
        .then(() => {
          this.showDialog = false
          this.selectItem = undefined
          this.$message.success('操作成功！')
          this.refreshData(!isEdit)
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '操作失败，请重试！')
          console.error(err)
        })
    }
  }
}
</script>
